module.exports = __webpack_public_path__ + "media/images/games/35reveal/tile-bcd5ac434c7f59652111f3c2d848cf80.png";